var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Header'),_c('Banner'),(_vm.shouldShowSubmission)?_c('Submission'):_vm._e(),(false)?_c('Loading'):_vm._e(),(true)?_c('router-view',{staticClass:"view"}):_vm._e(),(true)?_c('Footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }